<template>
  <div class="container footer">
    <div>
      <b-img :src="require('../../assets/common/logo_footer.png')"></b-img>
    </div>
    <div>
      <a href="http://www.mad-podlogi.pl"><h4>http://www.mad-podlogi.pl</h4></a>
      <h4>tel.: +48 725075423</h4>
    </div>
    <div class="socialMedia col-12">
      <a href="http://www.facebook.com/MADPODLOGI/" target="_blank"
        ><b-img :src="require('../../assets/common/facebook.png')"></b-img
      ></a>
      <a href="https://www.instagram.com/mad_podlogi/" target="_blank"
        ><img :src="require('../../assets/common/instagram.png')"
      /></a>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.footer {
  margin-top: 2%;
  margin-bottom: 2%;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  color: white;
}
a {
  color: white;
}

.socialMedia {
  display: flex;
  direction: row;
  align-items: center;
  justify-content: center;
  margin: 1%;
}

.socialMedia a {
  filter: invert(50%);
  margin: 0% 2%;
}
.socialMedia a:hover {
  cursor: pointer;
  filter: invert(100%);
}
</style>
